import { motion } from "framer-motion";
import { MessageCircle, MonitorSmartphone, PenTool, TrendingUp, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data/content";

const ICONS = { MessageCircle, MonitorSmartphone, PenTool, TrendingUp };

export const Services = () => {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 md:py-32"
    >
      <div className="mb-14 md:mb-20">
        <h2 className="font-display font-black text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.9] max-w-2xl">
          Todo lo que tu marca necesita para{" "}
          <span className="text-green">brillar</span>.
        </h2>
        <p className="text-ink/60 max-w-md text-base mt-6">
          Cuatro servicios, un mismo objetivo: hacer crecer tu negocio en digital.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-5">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          const dark = i === 0 || i === 3;
          return (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
              whileHover={{ y: -6 }}
              data-testid={`service-card-${i}`}
              className={`group relative overflow-hidden rounded-3xl p-8 md:p-12 border ${
                dark
                  ? "bg-forest text-cream border-forest md:mt-10"
                  : "bg-white text-ink border-ink/10"
              }`}
            >
              {dark && (
                <div className="noise-overlay absolute inset-0 opacity-10 pointer-events-none" />
              )}
              <div className="relative flex items-center justify-between mb-10">
                <span
                  className={`grid place-items-center h-14 w-14 rounded-2xl ${
                    dark ? "bg-mango text-ink" : "bg-green text-ink"
                  }`}
                >
                  <Icon size={26} />
                </span>
                <ArrowUpRight
                  size={30}
                  className={`transition-transform duration-300 group-hover:rotate-45 ${
                    dark ? "text-mango" : "text-ink/30 group-hover:text-green"
                  }`}
                />
              </div>
              <p
                className={`text-xs font-bold tracking-[0.2em] uppercase mb-3 ${
                  dark ? "text-mango" : "text-green"
                }`}
              >
                {s.tag}
              </p>
              <h3 className="font-display font-bold text-2xl md:text-3xl tracking-tight mb-4">
                {s.title}
              </h3>
              <p className={`text-base leading-relaxed ${dark ? "text-cream/70" : "text-ink/60"}`}>
                {s.text}
              </p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
